import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SettingsIcon from '@mui/icons-material/Settings';
import LanguageIcon from '@mui/icons-material/Language';
import { useNavigate } from 'react-router-dom';
import { iconButtonStyle } from 'pages/DashboardHelpers';


const ParametersAndLocalizationButtons = ({ dashboardrole, userEmail }) => {

  const navigate = useNavigate();

  const handleParametersClick = () => {
    navigate(`/ocplc/parameters`);
};

  const handleLocalizationClick = () => {
     navigate(`/ocplc/localization`);
  };

  return (
    <div>
      <Tooltip title="Parameters">
        <IconButton
          onClick={handleParametersClick}
          aria-label="parameters"
          sx={{ ...iconButtonStyle }}
          size="large"
          color="primary"
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Localization">
        <IconButton
          onClick={handleLocalizationClick}
          aria-label="localization"
          sx={{ ...iconButtonStyle }}
          size="large"
          color="primary"
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ParametersAndLocalizationButtons;